import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class CustomHttpInterceptorService {
  constructor(private storageService: StorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.baseApiUrl) || req.url.startsWith(environment.baseApiUrlV2) || req.url.includes(environment.testApi)) {
      //let includeToken = req.url.includes("gis-token");
      req = req.clone({
        setHeaders: {
          'X-App-Name': 'Cropmap',
          platform: 'mobile',
          apiVersion: '1.1',
          roleId: '37',
          campaignId: '280',
          companyId: '193',
          'Accept-Language': 'en-US,en;q=0.9',
        },
      });
      let userValue = this.storageService.Get('cropmap_userInfo');
      if (userValue) {
        req = req.clone({
          setHeaders: {
            token: userValue.Token,
            Authorization: userValue.AuthToken,
          },
        });
      }
    }
    return next.handle(req).pipe(
      retry(2),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }),
      finalize(() => {
        const profilingMsg = `${req.method} "${req.urlWithParams}"`;
      }),
    );
  }
}
